import { render, staticRenderFns } from "./GraduatesSingleInitialCapabilityItem.vue?vue&type=template&id=8bc4e196&"
import script from "./GraduatesSingleInitialCapabilityItem.vue?vue&type=script&lang=js&"
export * from "./GraduatesSingleInitialCapabilityItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports